import React, { useEffect, useState } from 'react';
import api from '../api';

export default function DnsReverse() {
  const [tab, setTab] = useState('v4');
  const [zones, setZones] = useState({ ipv4: [], ipv6: [] });
  const [block, setBlock] = useState('');
  const [desc, setDesc] = useState('');
  const [plen, setPlen] = useState('/64');
  const [msg, setMsg] = useState('');

  const load = () => api.get('/dns/reverse/zones').then(r => setZones(r.data));
  useEffect(() => { load(); }, []);

  const addV4 = async () => {
    try { const r = await api.post('/dns/reverse/ipv4', { block, description: desc }); setMsg(r.data.output); setBlock(''); setDesc(''); load(); }
    catch (e) { setMsg(e.response?.data?.error || 'Erro'); }
  };
  const addV6 = async () => {
    try { const r = await api.post('/dns/reverse/ipv6', { prefix: block, prefixlen: plen }); setMsg(r.data.output); setBlock(''); load(); }
    catch (e) { setMsg(e.response?.data?.error || 'Erro'); }
  };

  return (
    <>
      <div className="page-title"><h1>DNS · Reverso</h1></div>
      <div className="tab-bar">
        <div className={'tab ' + (tab==='v4'?'active':'')} onClick={()=>setTab('v4')}>IPv4</div>
        <div className={'tab ' + (tab==='v6'?'active':'')} onClick={()=>setTab('v6')}>IPv6</div>
      </div>

      {tab === 'v4' ? (
        <>
          <h3>Blocos IPv4</h3>
          <ul style={{fontFamily:'JetBrains Mono'}}>{zones.ipv4.map(z => <li key={z}>{z}</li>)}</ul>
          <h3 style={{marginTop:'1.5rem'}}>Adicionar bloco IPv4 (/24)</h3>
          <input value={block} onChange={e=>setBlock(e.target.value)} placeholder="203.0.113" />
          <label>Descrição</label>
          <input value={desc} onChange={e=>setDesc(e.target.value)} />
          <div style={{marginTop:'.6rem'}}><button onClick={addV4} disabled={!block}>Criar</button></div>
        </>
      ) : (
        <>
          <h3>Blocos IPv6</h3>
          <ul style={{fontFamily:'JetBrains Mono'}}>{zones.ipv6.map(z => <li key={z}>{z}</li>)}</ul>
          <h3 style={{marginTop:'1.5rem'}}>Adicionar bloco IPv6</h3>
          <label>Prefixo</label>
          <input value={block} onChange={e=>setBlock(e.target.value)} placeholder="2001:db8:0:0" />
          <label>Prefixo length</label>
          <select value={plen} onChange={e=>setPlen(e.target.value)}>
            <option>/48</option><option>/56</option><option>/64</option>
          </select>
          <div style={{marginTop:'.6rem'}}><button onClick={addV6} disabled={!block}>Criar</button></div>
        </>
      )}
      {msg && <pre className="code" style={{marginTop:'1rem'}}>{msg}</pre>}
    </>
  );
}
